// MainLayout.tsx
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useAuth } from "../context/AuthContext";
import { CategoriesProvider } from "../context/CategoriesContext";

const MainLayout = () => {
  const { isAuthenticated, user } = useAuth();
  const isAdmin = isAuthenticated && user?.role !== "customer";

  return (
    <>
      {!isAdmin ? (
        <CategoriesProvider>
          <Header role={user?.role ?? "customer"} />

          <main>
            <Outlet />
          </main>

          <Footer />
        </CategoriesProvider>
      ) : (
        <Header role={user?.role} />
      )}
    </>
  );
};

export default MainLayout;
